import KpiCard from './KpiCard'

interface KpiCardsContainerProps {
  kpiData: {
    currentMargin: number
    sixMonthsAgoMargin: number
    improvement: number
    growthRate: number
  }
}

const KpiCardsContainer = ({kpiData}: KpiCardsContainerProps) => {
  return (
    <div className='row g-5 mb-10'>
      <KpiCard
        title='Current Margin'
        value={kpiData.currentMargin}
        variant='primary'
        disableDynamicColors={true}
      />
      <KpiCard
        title='6 Months Ago'
        value={kpiData.sixMonthsAgoMargin}
        variant='muted'
        disableDynamicColors={true}
      />
      <KpiCard title='Improvement' value={kpiData.improvement} variant='success' showPlus={true} />
      <KpiCard title='Growth Rate' value={kpiData.growthRate} variant='success' showPlus={true} />
    </div>
  )
}

export default KpiCardsContainer
